import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { baseUrl } from "../Utility/constants";

const useTeacherStudents = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const teacherId = localStorage.getItem("userID");

  const fetchStudents = useCallback(async () => {
    if (!teacherId) return;

    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(
        `${baseUrl}/api/Attendance/GetStudentsWithAttendanceByTeacherId?TeacherId=${teacherId}`
      );

      setStudents(response.data || []);
    } catch (err) {
      setError("Failed to load students");
    } finally {
      setLoading(false);
    }
  }, [teacherId]);

  useEffect(() => {
    fetchStudents();
  }, [fetchStudents]);

  return { students, loading, error, refetch: fetchStudents };
};

export default useTeacherStudents;
